import { render, staticRenderFns } from "./UploadPackage.vue?vue&type=template&id=f1bbdf78&scoped=true&"
import script from "./uploadPackage.js?vue&type=script&lang=js&"
export * from "./uploadPackage.js?vue&type=script&lang=js&"
import style0 from "./UploadPackage.vue?vue&type=style&index=0&id=f1bbdf78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1bbdf78",
  null
  
)

export default component.exports